// Backend is returning HTML with CSS blocks that are not supported by react-markdown
// This function removes the CSS blocks
export const removeCssFromMarkdown = (rawContent) => {
	// Remove CSS blocks that start with * or other selectors
	return rawContent.replace(/^.*?\}\}\s*/, '').trim();
};
